<span class="basic-cell">
  {{ dataToDisplay() | infoDisplay }}
</span>
